module.exports = __webpack_public_path__ + "img/calendar-broken.106fbdc6.svg";